export enum EnterpriseAuthResult {
	Permitted = "permitted",
	Loading = "loading",
	Forbidden = "forbidden",
	Error = "error",
}
